import * as angular from "angular";
import { ModalTabHandle } from "./modalTabHandle";
import template from "./tabbed-modal-tab.html";
import type { TabbedModalController } from "./tabbed-modal";
import type { ModalTabItem } from "./tabbed-modal-types";

export interface TabbedModalTabController {
	tabbedModal: TabbedModalController;
	tab?: ModalTabItem;
}

// AngularJS owns these merged binding properties; keeping them type-only preserves pre-assigned values.
// eslint-disable-next-line no-redeclare
export class TabbedModalTabController {
	public static $inject = ["$element"];

	public handle?: ModalTabHandle;

	public constructor(private readonly $element: angular.IAugmentedJQuery) {}

	public $onInit(): void {
		if(this.tab) {
			this.handle = this.tabbedModal.tabs.add(
				new ModalTabHandle(this.tab, this.$element[0])
			);
		}
	}

	public isActive(): boolean {
		return this.handle?.isSelectable === true
			&& this.handle.isSame(this.tabbedModal.selected);
	}
}

export default angular
	.module("vesl.components.tabbed-modal.tab", [])
	.component("tabbedModalTab", {
		template,
		transclude: true,
		controller: TabbedModalTabController,
		bindings: {
			tab: "<"
		},
		require: {
			tabbedModal: "^^tabbedModal"
		}
	})
	.name;
